import {
  Autocomplete,
  Button,
  createFilterOptions,
  Grid2,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { commonCss } from "../../StyleConfig/CommonCss";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import Loading from "../../Component/Loading";
import { api, companyInfo, roleInfo, terminalInfo } from "../API/config";
import { axiosPrivate } from "../../axios/axios";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TableContainerComp from "../../Component/TableContainer";
import NormalTable from "../../Component/NormalTable";
import ExportCSV from "./ExportCSV";
import { common } from "@mui/material/colors";

const Dashboard = () => {
  const login = useSelector((state) => state.auth.loginInfo);
  const loginRoleId = String(login.roleIds).split(",");
  const [fromDate, setFromDate] = useState(
    moment().utc().subtract(1, "week").format("YYYY-MM-DD") + "T00:00:00Z",
  );
  const [companyId, setCompanyId] = useState(null);
  const [terminalId, setTerminalId] = useState(null);
  const [toDate, setToDate] = useState(
    moment().utc().format("YYYY-MM-DD") + "T00:00:00Z",
  );
  const [dashboardData, setDashboardData] = useState({
    totalDurationText: 0,
    manDays: 0,
  });
  const [tabledata, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [comAuto, setComAuto] = useState("");
  const [comAutoTer, setcomAutoTer] = useState(
    loginRoleId.includes(roleInfo.admin) ? "" : login.terminalName,
  );

  // const [terminalId, setTerminalId] = useState(null);
  // const [siteId, setSiteId] = useState(null);
  const [companyData, setCompanyData] = useState([]);
  const [terminalData, setTerminalData] = useState([]);
  // const [siteData, setSiteData] = useState([]);
  const [noData, setnoData] = useState(false);
  const [autoValue, setAutoValue] = useState(null);
  const [autoValueTer, setAutoValueTer] = useState(null);

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };
  useEffect(() => {
    getData();
    getCompanyDetail();
    getTerminalDetail();
  }, []);
  const getData = () => {
    setLoading(true);
    const payload = {
      from: fromDate,
      to: toDate,
      terminalId: terminalId,
      siteId: null,
      companyId: companyId,
    };
    const getLink = api.report.ShiftSummaryDateRange;
    axiosPrivate
      .post(`${getLink}`, payload)
      .then((res) => {
        console.log(res);
        setnoData(false);
        setDashboardData(res.data.data);
        setTableData(res.data.data.allDetails);
        setLoading(false);
      })
      .catch((e) => {
        // if (
        //   e.response.data.message ===
        //   "No forms available in the specified date range."
        // ) {
        setDashboardData({ totalDurationText: 0, manDays: 0 });
        setnoData(true);
        // } else {
        //   setnoData(false);
        // }
        console.log(e);
        setLoading(false);
      });
  };

  const getCompanyDetail = () => {
    const getCompanyInfo = api.company.getAll;
    axiosPrivate
      .get(`${getCompanyInfo}`)
      .then((res) => {
        console.log(res);
        setCompanyData(res.data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getTerminalDetail = () => {
    const getCompanyInfo = api.terminal.getAll;
    axiosPrivate
      .get(`${getCompanyInfo}`)
      .then((res) => {
        console.log("Terminal", res);
        setTerminalData(res.data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleClear = () => {
    setLoading(true);
    const getLink = api.report.ShiftSummaryDateRange;
    axiosPrivate
      .post(`${getLink}`, {
        from: moment().utc().subtract(1, "week"),
        to: moment().utc(),
        comapanyId: null,
        siteId: null,
        terminalId: null,
      })
      .then((res) => {
        console.log(res);
        setnoData(false);
        // setTerminalId(null);
        // setSiteId(null);
        setFromDate(
          moment().utc().subtract(1, "week").format("YYYY-MM-DD") +
            "T00:00:00Z",
        );
        setToDate(moment().utc().format("YYYY-MM-DD") + "T00:00:00Z");
        setDashboardData(res.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        if (
          e.response.data.message ===
          "No forms available in the specified date range."
        ) {
          setnoData(true);
          // setDashboardData(0)
        } else {
          setnoData(false);
          setDashboardData({ totalDurationText: 0, manDays: 0 });
        }
        console.log(e);
      });
  };

  const columns = [
    {
      Header: "Form No",
      accessor: "seqNo",
      // Cell: ({ cell }) => {
      //   return (
      //     <></>
      //      // to={`/ptwform?id=${btoa(cell.row.original.id)}&no=${cell.value}&requestor=${btoa(roleName)}`}
      //       style={{
      //          color: "#FD0000",
      //         // textDecorationLine: "underline",
      //         // textDecorationColor: "rgb(0, 86, 151)",
      //         cursor:"default",
      //         fontWeight: 800,
      //       }}
      //       // onClick={() => {
      //       //   dispatch(
      //       //     permitStatus({
      //       //       permitStatus: cell.row.original.permitStatus,
      //       //       isPermitShift: cell.row.original.isPermitShift,
      //       //     })
      //       //   );
      //       // }}

      //    </>
      //   );
      // },
    },
    {
      Header: "Total Hour",
      accessor: "totalHours",
    },
    {
      Header: "Total Man Days",
      accessor: "manDays",
    },
     {
      Header: "Man Power",
      accessor: "noOfStaff",
    },
    {
      Header: "Role Name",
      accessor: "formTypeName",
      Cell: ({ value, cell }) => {
        if (terminalInfo.terminal1 === cell.row.original.terminalId) {
          if (value === "KVDT") return "Controller";
          if (value === "MPP") return "OE";
        } else {
          return "Controller";
        }
        return value;
      },
    },
  ];
  return (
    <Grid2 container spacing={"0.6rem"}>
      <Grid2 size={12}>
        <Paper
          sx={{
            p: 1,
            background: "white",
          }}
        >
          <Grid2 container spacing={"0.6rem"}>
            <Grid2 size={12}>
              <Typography
                sx={{
                  color: commonCss.darkBlue,
                  fontSize: "1.5rem",
                  fontWeight: 600,
                  p: 1,
                }}
              >
                Report
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 3 }}>
              <InputLabel>
                <Typography
                  variant="body2"
                  fontWeight={commonCss.labelFontWeight}
                  color={commonCss.labelInputColor}
                >
                  From
                </Typography>
              </InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                  <DatePicker
                    ampm={false}
                    format="DD/MM/YYYY"
                    value={dayjs(fromDate)}
                    slotProps={{
                      textField: {
                        size: "small",
                        variant: "outlined",
                      },
                    }}
                    onChange={(newValue) => {
                      console.log(newValue);
                      if (newValue !== null) {
                        if (`${newValue.$d}` !== "Invalid Date") {
                          const dateFrom =
                            moment(newValue.$d).format("YYYY-MM-DD") +
                            "T00:00:00Z";
                          // const dateFrom = moment(newValue.$d).format(
                          //   "YYYY-MM-DD"
                          // );

                          // const hour =
                          //   new Date().getHours() < 10
                          //     ? "0" + new Date().getHours()
                          //     : new Date().getHours();
                          // const min =
                          //   new Date().getMinutes() < 10
                          //     ? "0" + new Date().getMinutes()
                          //     : new Date().getMinutes();
                          // const sec =
                          //   new Date().getSeconds() < 10
                          //     ? "0" + new Date().getSeconds()
                          //     : new Date().getSeconds();
                          // const dateFormat =
                          //   dateFrom + "T" + hour + ":" + min + ":" + sec + "Z";
                          setFromDate(dateFrom);
                        }
                      }
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: commonCss.inputBorderRadius,
                        backgroundColor: commonCss.inputBackgroundColor,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: commonCss.inputBorderColor,
                      },
                    }}
                    fullWidth
                  />
                </DemoItem>
              </LocalizationProvider>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 3 }}>
              <InputLabel>
                <Typography
                  variant="body2"
                  fontWeight={commonCss.labelFontWeight}
                  color={commonCss.labelInputColor}
                >
                  To
                </Typography>
              </InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                  <DatePicker
                    ampm={false}
                    format="DD/MM/YYYY"
                    value={dayjs(toDate)}
                    slotProps={{
                      textField: {
                        size: "small",
                        variant: "outlined",
                      },
                    }}
                    onChange={(newValue) => {
                      console.log(newValue);
                      if (newValue !== null) {
                        if (`${newValue.$d}` !== "Invalid Date") {
                          const dateFrom =
                            moment(newValue.$d).format("YYYY-MM-DD") +
                            "T00:00:00Z";
                          // const dateFrom = moment(newValue.$d).format(
                          //   "YYYY-MM-DD"
                          // );

                          // const hour =
                          //   new Date().getHours() < 10
                          //     ? "0" + new Date().getHours()
                          //     : new Date().getHours();
                          // const min =
                          //   new Date().getMinutes() < 10
                          //     ? "0" + new Date().getMinutes()
                          //     : new Date().getMinutes();
                          // const sec =
                          //   new Date().getSeconds() < 10
                          //     ? "0" + new Date().getSeconds()
                          //     : new Date().getSeconds();
                          // const dateFormat =
                          //   dateFrom + "T" + hour + ":" + min + ":" + sec + "Z";
                          setToDate(dateFrom);

                          // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                          // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                          // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                          // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                          // setFieldValue("installationDate", dateFormat);
                        }
                      }
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: commonCss.inputBorderRadius,
                        backgroundColor: commonCss.inputBackgroundColor,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: commonCss.inputBorderColor,
                      },
                    }}
                    fullWidth
                  />
                </DemoItem>
              </LocalizationProvider>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 3 }}>
              <InputLabel>
                <Typography
                  variant="body2"
                  fontWeight={commonCss.labelFontWeight}
                  color={commonCss.labelInputColor}
                >
                  Contractor
                </Typography>
              </InputLabel>
              <Autocomplete
                name="companyId"
                inputValue={comAuto}
                value={autoValue}
                filterOptions={filterOptions}
                loading={companyData.length === 0 && loading}
                options={companyData}
                PaperComponent={CustomPaper}
                getOptionLabel={(option) => option.name || option}
                onChange={(event, value) => {
                  if (value) {
                    setAutoValue(value);
                    setCompanyId(value.id);
                    setComAuto(value.name);
                  } else {
                    setAutoValue(null);
                    setCompanyId(null);
                    setComAuto("");
                  }
                }}
                // onInputChange={(e, v, reason) => {
                //   if (reason === 'input') {
                //     setComAuto(v); // Only update on user input, not on selection
                //   }
                // }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="companyId"
                    size="small"
                    onChange={(e) => {
                      setComAuto(e.target.value); // Only update on user input, not on selection
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: commonCss.inputBackgroundColor,
                        borderRadius: commonCss.inputBorderRadius,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: commonCss.inputBorderColor,
                      },
                    }}
                  />
                )}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 3 }}>
              <InputLabel>
                <Typography
                  variant="body2"
                  fontWeight={commonCss.labelFontWeight}
                  color={commonCss.labelInputColor}
                >
                  Terminal
                </Typography>
              </InputLabel>
              <Autocomplete
                name="terminalId"
                inputValue={comAutoTer}
                value={autoValueTer}
                readOnly={!loginRoleId.includes(roleInfo.admin)}
                filterOptions={filterOptions}
                loading={terminalData.length === 0 && loading}
                options={terminalData}
                PaperComponent={CustomPaper}
                getOptionLabel={(option) => option.name || option}
                onChange={(event, value) => {
                  if (value) {
                    setAutoValueTer(value);
                    setTerminalId(value.id);
                    setcomAutoTer(value.name);
                  } else {
                    setAutoValue(null);
                    setTerminalId(null);
                    setcomAutoTer("");
                  }
                }}
                // onInputChange={(e, v, reason) => {
                //   if (reason === 'input') {
                //     setComAuto(v); // Only update on user input, not on selection
                //   }
                // }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="terminalId"
                    size="small"
                    onChange={(e) => {
                      setComAuto(e.target.value); // Only update on user input, not on selection
                    }}
                    // sx={{
                    //   "& .MuiOutlinedInput-root": {
                    //     backgroundColor: commonCss.inputBackgroundColor,
                    //     borderRadius: commonCss.inputBorderRadius,
                    //   },
                    //   "& .MuiOutlinedInput-notchedOutline": {
                    //     borderColor: commonCss.inputBorderColor,
                    //   },
                    // }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: !loginRoleId.includes(roleInfo.admin)
                          ? commonCss.readOnlyBGColor
                          : commonCss.inputBackgroundColor,
                        borderRadius: commonCss.inputBorderRadius,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: commonCss.inputBorderColor,
                      },
                    }}
                  />
                )}
              />
            </Grid2>
            {/* <Grid2 size={{ xs: 12, md: 3 }}>
              <InputLabel sx={{ pl: 0.5 }}>
                <Typography variant="body2" fontWeight="500" color="black">
                  Terminal
                </Typography>
              </InputLabel>
              <Select
                size="small"
                defaultValue=""
                displayEmpty
                name="terminalId"
                value={terminalId}
                sx={{
                  borderRadius: "13px",
                  backgroundColor: commonCss.inputBackgroundColor,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "747373",
                  },
                }}
                onChange={(e) => {
                  setTerminalId(e.target.value);
                }}
                fullWidth
              >
                {terminalData.map((term, i) => (
                  <MenuItem key={i} value={term.id}>
                    {term.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid2>
            <Grid2
              size={{ xs: 12, md: 3 }}
              sx={{
                display:
                  terminalId === terminalInfo.terminal1 ? "default" : "none",
              }}
            >
              <InputLabel sx={{ pl: 0.5 }}>
                <Typography variant="body2" fontWeight="500" color="black">
                  Site
                </Typography>
              </InputLabel>
              <Select
                size="small"
                defaultValue=""
                displayEmpty
                name="siteId"
                value={siteId}
                sx={{
                  borderRadius: "13px",
                  background: commonCss.inputBackgroundColor,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "747373",
                  },
                }}
                onChange={(e) => {
                  setSiteId(e.target.value);
                }}
                fullWidth
              >
                {siteData.map((siteList, i) => (
                  <MenuItem key={i} value={siteList.id}>
                    {siteList.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid2> */}
            <Grid2 container size={{ xs: 12 }} justifyContent={"flex-end"}>
              <ExportCSV
                columns={columns}
                data={tabledata}
                dashboardData={dashboardData}
              />

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "rgb(0, 86, 151)",
                  borderRadius: commonCss.buttonBorderRadius,
                  textTransform: "none",
                  padding: "0.6rem 1rem",
                  color: commonCss.buttonTextColor,
                  width: "15vw",
                }}
                onClick={() => {
                  handleClear();
                }}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "rgb(0, 86, 151)",
                  borderRadius: commonCss.buttonBorderRadius,
                  textTransform: "none",
                  padding: "0.6rem 1rem",
                  color: commonCss.buttonTextColor,
                  width: "15vw",
                }}
                onClick={() => {
                  getData();
                }}
              >
                Search
              </Button>
            </Grid2>
          </Grid2>
        </Paper>
      </Grid2>
      {loading || dashboardData === null ? (
        <Loading color={commonCss.blue} />
      ) : (
        <>
          {noData ? (
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: 450,
                color: "black",
                textAlign: "center",
                width: "100%",
                mt: 1,
              }}
            >
              No Data
            </Typography>
          ) : (
            <Grid2 container size={12} spacing={"0.6rem"}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "100%",
                    p: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                    background: "white",
                  }}
                >
                  <Typography sx={{ fontWeight: 500 }}>Total Hours</Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: "1.3rem" }}>
                    {dashboardData?.totalDurationText}
                  </Typography>
                </Paper>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "100%",
                    p: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                    background: "white",
                  }}
                >
                  <Typography sx={{ fontWeight: 500 }}>
                    Total Man Days
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: "1.3rem" }}>
                    {dashboardData?.manDays}
                  </Typography>
                </Paper>
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 12 }}
                sx={{
                  background: "white",
                  boxShadow: "0px 5px 10px #00000033",
                  // border: "0.5px solid rgb(187 187 187 / 31%)",
                  // borderRadius: "10px",
                }}
              >
                <NormalTable
                  paginationProps={true}
                  filt={true}
                  columns={columns}
                  data={tabledata}
                />
              </Grid2>
              {/* <Grid2 size={{ xs: 12, md: 3 }}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "100%",
                    p: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                    background: "white",
                  }}
                >
                  <Typography sx={{ fontWeight: 500 }}>
                    Permit To Work Reject
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: "1.3rem" }}>
                    {dashboardData?.summaryData?.rejectForms}
                  </Typography>
                </Paper>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 3 }}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "100%",
                    p: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                    background: "linear-gradient(to right, white, white)",
                  }}
                >
                  <Typography sx={{ fontWeight: 500 }}>
                    Permit To Work Expired
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: "1.3rem" }}>
                    {dashboardData?.summaryData?.notClosedWithinSevenDays}
                  </Typography>
                </Paper>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "100%",
                    p: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                    background: " white",
                  }}
                >
                  <PermitByStatus data={dashboardData} />
                </Paper>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "100%",
                    p: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                    background: "linear-gradient(to right, white, white)",
                  }}
                >
                  <PermitByCertificate data={dashboardData} />
                </Paper>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 12 }}>
                <Paper
                  sx={{
                    width: "100%",
                    height: "100%",
                    p: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                    background: "linear-gradient(to right, white, white)",
                  }}
                >
                  <PermitByStatusDaily data={dashboardData} />
                </Paper>
              </Grid2> */}
            </Grid2>
          )}
        </>
      )}
    </Grid2>
  );
};

export default Dashboard;




